import { render, staticRenderFns } from "./newsListHotspots.vue?vue&type=template&id=0165ed73&scoped=true&"
import script from "./newsListHotspots.vue?vue&type=script&lang=js&"
export * from "./newsListHotspots.vue?vue&type=script&lang=js&"
import style0 from "./newsListHotspots.vue?vue&type=style&index=0&id=0165ed73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0165ed73",
  null
  
)

export default component.exports